module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = {"allCohorts": __webpack_require__(1),
	"allDatasetsN": __webpack_require__(2),
	"allFieldMetadata": __webpack_require__(3),
	"cohortSamples": __webpack_require__(4),
	"cohortSummary": __webpack_require__(5),
	"datasetChromProbeValues": __webpack_require__(6),
	"datasetFetch": __webpack_require__(7),
	"datasetField": __webpack_require__(8),
	"datasetFieldExamples": __webpack_require__(9),
	"datasetFieldN": __webpack_require__(10),
	"datasetGeneProbeAvg": __webpack_require__(11),
	"datasetGeneProbesValues": __webpack_require__(12),
	"datasetList": __webpack_require__(13),
	"datasetMetadata": __webpack_require__(14),
	"datasetProbeSignature": __webpack_require__(15),
	"datasetProbeValues": __webpack_require__(16),
	"datasetSamples": __webpack_require__(17),
	"datasetSamplesExamples": __webpack_require__(18),
	"datasetSamplesHTFCExamples": __webpack_require__(19),
	"datasetSamplesNDenseMatrix": __webpack_require__(20),
	"datasetStatus": __webpack_require__(21),
	"featureList": __webpack_require__(22),
	"fieldCodes": __webpack_require__(23),
	"fieldMetadata": __webpack_require__(24),
	"geneTranscripts": __webpack_require__(25),
	"matchFields": __webpack_require__(26),
	"maxRange": __webpack_require__(27),
	"probemapList": __webpack_require__(28),
	"refGeneExons": __webpack_require__(29),
	"refGenePosition": __webpack_require__(30),
	"refGeneRange": __webpack_require__(31),
	"segmentDataExamples": __webpack_require__(32),
	"segmentedDataRange": __webpack_require__(33),
	"sparseData": __webpack_require__(34),
	"sparseDataExamples": __webpack_require__(35),
	"sparseDataMatchField": __webpack_require__(36),
	"sparseDataMatchFieldSlow": __webpack_require__(37),
	"sparseDataMatchPartialField": __webpack_require__(38),
	"sparseDataRange": __webpack_require__(39),
	"transcriptExpression": __webpack_require__(40)};


/***/ }),
/* 1 */
/***/ (function(module, exports) {

	module.exports = ";allCohorts\n(fn [exclude]\n\t(map :cohort\n\t  (query\n\t\t{:select [[#sql/call [:distinct #sql/call [:ifnull :cohort \"(unassigned)\"]] :cohort]]\n\t\t :from [:dataset]\n\t\t :where [:not [:in :type exclude]]})))\n"

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = "; allDatasetsN\n(fn []\n\t(count (query {:select [:cohort]\n               :from [:dataset]\n               :where [:<> :cohort nil]})))\n               "

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	module.exports = "; allFieldMetadata\n(fn [dataset]\n\t(query {:select [:field.name :feature.*]\n\t\t\t:from [:field]\n\t\t\t:where [:= :dataset_id {:select [:id]\n\t\t\t\t\t\t\t :from [:dataset]\n\t\t\t\t\t\t\t :where [:= :name dataset]}]\n\t\t\t:left-join [:feature [:= :feature.field_id :field.id]]}))\n"

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	module.exports = "; cohortSamples\n(fn [cohort limit]\n    (map :value\n      (query\n        {:select [:%distinct.value]\n         :from [:dataset]\n         :join [:field [:= :dataset.id :dataset_id]\n                :code [:= :field_id :field.id]]\n         :limit limit\n         :where [:and [:= :cohort cohort]\n                      [:= :field.name \"sampleID\"]]})))\n"

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	module.exports = "; cohortSummary\n(fn [exclude]\n\t(query {:select [:cohort [:%count.* :count]]\n\t\t\t:from [:dataset]\n\t\t\t:where [:not [:in :type exclude]]\n\t\t\t:group-by [:cohort]}))\n"

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	module.exports = "; datasetChromProbeValues\n(fn [dataset samples chr start end]\n\t(let [probemap (:probemap (car (query {:select [:probemap]\n\t\t\t\t\t\t\t\t\t\t   :from [:dataset]\n\t\t\t\t\t\t\t\t\t\t   :where [:= :name dataset]})))\n\t\t\tposition (xena-query {:select [\"name\" \"position\"] :from [probemap] :where [:in \"position\" [[chr start end]]]})\n\t\t\tprobes (position \"name\")]\n\t  [position\n\t\t(fetch [{:table dataset\n\t\t\t\t :samples samples\n\t\t\t\t :columns probes}])]))\n\n"

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	module.exports = "; datasetFetch\n(fn [dataset samples probes]\n  (fetch [{:table dataset\n           :columns probes\n           :samples samples}]))\n"

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	module.exports = "; datasetField\n(fn [dataset]\n  (map :name (query {:select [:field.name]\n                     :from [:dataset]\n                     :join [:field [:= :dataset.id :dataset_id]]\n                     :where [:= :dataset.name dataset]})))\n"

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	module.exports = "; datasetFieldExamples\n(fn [dataset count]\n    (map :name (query {:select [:field.name]\n                       :from [:dataset]\n                       :join [:field [:= :dataset.id :dataset_id]]\n                       :where [:= :dataset.name dataset]\n                       :limit count})))\n"

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	module.exports = "; datasetFieldN\n(fn [dataset]\n   (:count (car (query {:select [[:%count.field.name :count]]\n                        :from [:dataset]\n                        :join [:field [:= :dataset.id :dataset_id]]\n                        :where [:= :dataset.name dataset]}))))\n"

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	module.exports = "; datasetGeneProbeAvg\n(fn [dataset samples genes]\n\t(let [probemap (:probemap (car (query {:select [:probemap]\n\t\t\t\t\t\t\t\t\t\t   :from [:dataset]\n\t\t\t\t\t\t\t\t\t\t   :where [:= :name dataset]})))\n\t\t  get-probes (fn [gene] (xena-query {:select [\"name\" \"position\"] :from [probemap] :where [:in :any \"genes\" [gene]]}))\n\t\t  avg (fn [scores] (mean scores 0))\n\t\t  scores-for-gene (fn [gene]\n\t\t\t  (let [probes (get-probes gene)\n\t\t\t\t\tprobe-names (probes \"name\")\n\t\t\t\t\tscores (fetch [{:table dataset\n\t\t\t\t\t\t\t\t\t:samples samples\n\t\t\t\t\t\t\t\t\t:columns probe-names}])]\n\t\t\t\t{:gene gene\n\t\t\t\t :position (probes \"position\")\n\t\t\t\t :scores (if (car probe-names) (avg scores) [[]])}))]\n\t  (map scores-for-gene genes)))\n"

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	module.exports = "; datasetGeneProbesValues\n(fn [dataset samples genes]\n\t(let [probemap (:probemap (car (query {:select [:probemap]\n\t\t\t\t\t\t\t\t\t\t   :from [:dataset]\n\t\t\t\t\t\t\t\t\t\t   :where [:= :name dataset]})))\n\t\t\tposition (xena-query {:select [\"name\" \"position\"] :from [probemap] :where [:in :any \"genes\" genes]})\n\t\t\tprobes (position \"name\")]\n\t  [position\n\t\t(fetch [{:table dataset\n\t\t\t\t :samples samples\n\t\t\t\t :columns probes}])]))\n"

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	module.exports = "; datasetList\n(fn [cohorts]\n    (let [count-table {:select [[:dataset.name :dname] [:%count.value :count]]\n                       :from [:dataset]\n                       :join [:field [:= :dataset.id :dataset_id]\n                              :code [:= :field.id :field_id]]\n                       :group-by [:dataset.name]\n                       :where [:= :field.name \"sampleID\"]}]\n        (query {:select [:d.name :d.longtitle :count :d.type :d.datasubtype :d.probemap :d.text :d.status [:pm-dataset.text :pmtext]]\n                   :from [[:dataset :d]]\n                   :left-join [[:dataset :pm-dataset] [:= :pm-dataset.name :d.probemap]\n                                count-table [:= :dname :d.name]]\n                   :where [:in :d.cohort cohorts]})))\n"

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	module.exports = "; datasetMetadata\n(fn [dataset]\n    (let [count-table {:select [[:dataset.name :dname] [:%count.value :count]]\n                       :from [:dataset]\n                       :join [:field [:= :dataset.id :dataset_id]\n                       :code [:= :field.id :field_id]]\n                       :group-by [:dataset.name]\n                       :where [:= :field.name \"sampleID\"]}]\n        (query {:select [:d.name :d.longtitle :count :d.type :d.datasubtype :d.probemap :d.text :d.status [:pm-dataset.text :pmtext]]\n                   :from [[:dataset :d]]\n                   :left-join [[:dataset :pm-dataset] [:= :pm-dataset.name :d.probemap]\n                                count-table [:= :dname :d.name]]\n                   :where [:= :d.name dataset]})))\n"

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	module.exports = ";datasetProbeSignature\n(fn [dataset samples probes weights]\n (let [vals (fetch [{:table dataset\n                     :samples samples\n                     :columns probes}])]\n     (apply + (map (fn [w v] (* v w)) weights vals))))\n"

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	module.exports = "; datasetProbeValues\n(fn [dataset samples probes]\n  (let [probemap (:probemap (car (query {:select [:probemap]\n                                         :from [:dataset]\n                                         :where [:= :name dataset]})))\n        position (if probemap\n                    (xena-query {:select [\"name\" \"position\"] :from [probemap] :where [:in \"name\" probes]})\n                    nil)]\n    [position\n     (fetch [{:table dataset\n              :columns probes\n              :samples samples}])]))\n\n"

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	module.exports = "; datasetSamples\n(fn [dataset limit]\n    (map :value\n      (query\n        {:select [:value]\n         :from [:dataset]\n         :join [:field [:= :dataset.id :dataset_id]\n                :code [:= :field.id :field_id]]\n         :limit limit\n         :where [:and\n                 [:= :dataset.name dataset]\n                 [:= :field.name \"sampleID\"]]})))\n"

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	module.exports = "; datasetSamplesExamples\n(fn [dataset count]\n\t(map :value\n\t  (query\n\t\t{:select [:value]\n\t\t :from [:dataset]\n\t\t :join [:field [:= :dataset.id :dataset_id]\n\t\t\t\t:code [:= :field.id :field_id]]\n\t\t :where [:and\n\t\t\t\t [:= :dataset.name dataset]\n\t\t\t\t [:= :field.name \"sampleID\"]]\n\t\t :limit count})))\n"

/***/ }),
/* 19 */
/***/ (function(module, exports) {

	module.exports = ";datasetSamplesHTFCExamples\n(fn [dataset count]\n  (take 10 (seq-htfc ((car (query {:select [:samples]\n                                   :from [:sample]\n                                   :join [:dataset [:= :dataset.id :dataset_id]]\n                                   :where [:= :name dataset]})) :samples))))\n"

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	module.exports = "; datasetSamplesNDenseMatrix\n(fn [dataset]\n    (map :rows\n        (query\n            {:select [:rows]\n             :from [:dataset]\n             :where [:= :name dataset]})))\n"

/***/ }),
/* 21 */
/***/ (function(module, exports) {

	module.exports = "; datasetStatus\n(fn [dataset]\n\t (query {:select [:status :text] :from [:dataset] :where [:= :name dataset]}))\n"

/***/ }),
/* 22 */
/***/ (function(module, exports) {

	module.exports = "; featureList\n(fn [dataset]\n\t(query {:select [:field.name :feature.longtitle]\n\t\t\t:from [:field]\n\t\t\t:where [:= :dataset_id {:select [:id]\n\t\t\t\t\t\t\t :from [:dataset]\n\t\t\t\t\t\t\t :where [:= :name dataset]}]\n\t\t\t:left-join [:feature [:= :feature.field_id :field.id]]}))\n\n"

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	module.exports = "; fieldCodes\n(fn [dataset fields]\n\t(query\n\t  {:select [:P.name [#sql/call [:group_concat :value :order :ordering :separator #sql/call [:chr 9]] :code]]\n\t   :from [[{:select [:field.id :field.name]\n\t\t\t\t:from [:field]\n\t\t\t\t:join [{:table [[[:name :varchar fields]] :T]} [:= :T.name :field.name]]\n\t\t\t\t:where [:= :dataset_id {:select [:id]\n\t\t\t\t\t\t\t\t :from [:dataset]\n\t\t\t\t\t\t\t\t :where [:= :name dataset]}]} :P]]\n\t   :left-join [:code [:= :P.id :field_id]]\n\t   :group-by [:P.id]}))\n"

/***/ }),
/* 24 */
/***/ (function(module, exports) {

	module.exports = "; fieldMetadata\n(fn [dataset fields]\n\t(query\n\t  {:select [:P.name :feature.*]\n\t   :from [[{:select [:field.name :field.id]\n\t\t\t\t:from [:field]\n\t\t\t\t:join [{:table [[[:name :varchar fields]] :T]} [:= :T.name :field.name]]\n\t\t\t\t:where [:= :dataset_id {:select [:id]\n\t\t\t\t\t\t\t\t :from [:dataset]\n\t\t\t\t\t\t\t\t :where [:= :name dataset]}]} :P]]\n\t   :left-join [:feature [:= :feature.field_id :P.id]]}))\n"

/***/ }),
/* 25 */
/***/ (function(module, exports) {

	module.exports = "; geneTranscripts\n(fn [dataset gene]\n\t(xena-query {:select [\"name\" \"position (2)\" \"position\" \"exonCount\" \"exonStarts\" \"exonEnds\"]\n\t\t\t\t :from [dataset]\n\t\t\t\t :where [:in :any \"name2\" [gene]]}))\n\n\n"

/***/ }),
/* 26 */
/***/ (function(module, exports) {

	module.exports = "; matchFields\n(fn [dataset names]\n\t(map :name (query {:select [:field.name]\n\t\t\t\t\t   :from [:dataset]\n\t\t\t\t\t   :join [:field [:= :dataset.id :field.dataset_id]]\n\t\t\t\t\t   :where [:and [:in :%lower.field.name names] [:= :dataset.name dataset]]})))\n"

/***/ }),
/* 27 */
/***/ (function(module, exports) {

	module.exports = "; maxRange\n(fn [dataset chr start end limit]\n\t(let [position (xena-query {:select [\"position\"] :from [dataset]\n                                :where [:in \"position\" [[chr start end]]]\n                                :offset limit :limit 1})]\n\t  (map :chromstart (position \"position\"))))\n"

/***/ }),
/* 28 */
/***/ (function(module, exports) {

	module.exports = ";probemapList\n(fn []\n  (query {:select [:dataset.name :text :hash]\n          :from [:dataset]\n          :join [:dataset-source [:= :dataset.id :dataset_id]\n            :source [:= :source.id :source_id]]\n          :where [:= :type \"probeMap\"]}))\n"

/***/ }),
/* 29 */
/***/ (function(module, exports) {

	module.exports = "; refGeneExons\n(fn [dataset genes]\n    (xena-query {:select [\"position (2)\" \"position\" \"exonCount\" \"exonStarts\" \"exonEnds\" \"name2\"]\n                 :from [dataset]\n                 :where [:in :any \"name2\" genes]}))\n"

/***/ }),
/* 30 */
/***/ (function(module, exports) {

	module.exports = "; refGenePosition\n(fn [dataset gene]\n\t(car ((xena-query {:select [\"position\"] :from [dataset] :where [:in :any \"name2\" [gene]]}) \"position\")))\n"

/***/ }),
/* 31 */
/***/ (function(module, exports) {

	module.exports = "; refGeneRange\n(fn [dataset chr start end]\n\t(xena-query {:select [\"position (2)\" \"position\" \"exonCount\" \"exonStarts\" \"exonEnds\" \"name2\"]\n\t\t\t\t:from [dataset]\n\t\t\t\t:where [:in \"position\" [[chr start end]]]}))"

/***/ }),
/* 32 */
/***/ (function(module, exports) {

	module.exports = "; sparseDataExample\n(fn [dataset count]\n\t{:rows (xena-query {:select [\"sampleID\" \"position\" \"value\"]\n\t\t\t\t\t\t:from [dataset]\n\t\t\t\t\t\t:limit count})})\n"

/***/ }),
/* 33 */
/***/ (function(module, exports) {

	module.exports = "; segmentedDataRange\n(fn [dataset samples chr start end]\n\t(let [getfield (fn [field]\n\t\t\t\t\t (:id (car (query {:select [:field.id]\n\t\t\t\t\t\t\t\t\t   :from [:dataset]\n\t\t\t\t\t\t\t\t\t   :join [:field [:= :dataset.id :field.dataset_id]]\n\t\t\t\t\t\t\t\t\t   :where [:and [:= :field.name field] [:= :dataset.name dataset]]}))))\n\t\t  sampleID (getfield \"sampleID\")]\n\t  {:samples (map :value (query {:select [:value]\n\t\t\t\t\t\t\t\t\t:from [:code]\n\t\t\t\t\t\t\t\t\t:where [:and [:in :value samples][:= :field_id sampleID]]}))\n\t   :rows (xena-query {:select [\"sampleID\" \"position\" \"value\"]\n\t\t\t\t\t\t  :from [dataset]\n\t\t\t\t\t\t  :where [:and [:in \"position\" [[chr start end]]] [:in \"sampleID\" samples]]})}))\n"

/***/ }),
/* 34 */
/***/ (function(module, exports) {

	module.exports = "; sparseData\n(fn [dataset samples genes]\n\t(let [getfield (fn [field]\n\t\t\t\t\t (:id (car (query {:select [:field.id]\n\t\t\t\t\t\t\t\t\t   :from [:dataset]\n\t\t\t\t\t\t\t\t\t   :join [:field [:= :dataset.id :field.dataset_id]]\n\t\t\t\t\t\t\t\t\t   :where [:and [:= :field.name field] [:= :dataset.name dataset]]}))))\n\t\t  sampleID (getfield \"sampleID\")]\n\t  {:samples (map :value (query {:select [:value]\n\t\t\t\t\t\t\t\t\t:from [:code]\n\t\t\t\t\t\t\t\t\t:where [:and [:in :value samples][:= :field_id sampleID]]}))\n\t   :rows (xena-query {:select [\"ref\" \"alt\" \"altGene\" \"effect\" \"dna-vaf\" \"rna-vaf\" \"amino-acid\" \"genes\" \"sampleID\" \"position\"]\n\t\t\t\t\t\t  :from [dataset]\n\t\t\t\t\t\t  :where [:and [:in :any \"genes\" genes] [:in \"sampleID\" samples]]})}))\n"

/***/ }),
/* 35 */
/***/ (function(module, exports) {

	module.exports = "; sparseDataExample\n(fn [dataset count]\n\t{:rows (xena-query {:select [\"ref\" \"alt\" \"altGene\" \"effect\" \"dna-vaf\" \"rna-vaf\" \"amino-acid\" \"genes\" \"sampleID\" \"position\"]\n\t\t\t\t\t\t:from [dataset]\n\t\t\t\t\t\t:limit count})})\n"

/***/ }),
/* 36 */
/***/ (function(module, exports) {

	module.exports = "; sparseDataMatchField\n(fn [field dataset names]\n\t(let [getfield (fn [field]\n\t\t\t\t\t (:id (car (query {:select [:field.id]\n\t\t\t\t\t\t\t\t\t   :from [:dataset]\n\t\t\t\t\t\t\t\t\t   :join [:field [:= :dataset.id :field.dataset_id]]\n\t\t\t\t\t\t\t\t\t   :where [:and [:= :field.name field] [:= :dataset.name dataset]]}))))\n\t\t  genes (getfield field)]\n\t  (map :gene (query {:select [:%distinct.gene]\n\t\t\t\t\t\t :from [:field_gene]\n\t\t\t\t\t\t :join [{:table [[[:name :varchar names]] :T]} [:= :T.name :gene]]\n\t\t\t\t\t\t :where [:= :field_gene.field_id genes]}))))\n"

/***/ }),
/* 37 */
/***/ (function(module, exports) {

	module.exports = "; sparseDataMatchFieldSlow\n(fn [field dataset names]\n\t(let [getfield (fn [field]\n\t\t\t\t\t (:id (car (query {:select [:field.id]\n\t\t\t\t\t\t\t\t\t   :from [:dataset]\n\t\t\t\t\t\t\t\t\t   :join [:field [:= :dataset.id :field.dataset_id]]\n\t\t\t\t\t\t\t\t\t   :where [:and [:= :field.name field] [:= :dataset.name dataset]]}))))\n\t\t  genes (getfield field)]\n\t  (map :gene (query {:select [:%distinct.gene]\n\t\t\t\t\t\t :from [:field_gene]\n\t\t\t\t\t\t :where [:and\n\t\t\t\t\t\t\t\t [:= :field_gene.field_id genes]\n\t\t\t\t\t\t\t\t [:in :%lower.gene names]]}))))\n\n"

/***/ }),
/* 38 */
/***/ (function(module, exports) {

	module.exports = "; sparseDataMatchPartialField\n(fn [field dataset names limit]\n\t(let [getfield (fn [field]\n\t\t\t\t\t (:id (car (query {:select [:field.id]\n\t\t\t\t\t\t\t\t\t   :from [:dataset]\n\t\t\t\t\t\t\t\t\t   :join [:field [:= :dataset.id :field.dataset_id]]\n\t\t\t\t\t\t\t\t\t   :where [:and [:= :field.name field] [:= :dataset.name dataset]]}))))\n\t\t  genes (getfield field)]\n\t  (map :gene (query {:select [:%distinct.gene]\n\t\t\t\t\t\t :limit limit\n\t\t\t\t\t\t :order-by [:gene]\n\t\t\t\t\t\t :from [:field_gene]\n\t\t\t\t\t\t :join [{:table [[[:name :varchar names]] :T]} [:like :gene :T.name]]\n\t\t\t\t\t\t :where [:= :field_gene.field_id genes]}))))\n"

/***/ }),
/* 39 */
/***/ (function(module, exports) {

	module.exports = "; sparseDataRange\n(fn [dataset samples chr start end]\n\t(let [getfield (fn [field]\n\t\t\t\t\t (:id (car (query {:select [:field.id]\n\t\t\t\t\t\t\t\t\t   :from [:dataset]\n\t\t\t\t\t\t\t\t\t   :join [:field [:= :dataset.id :field.dataset_id]]\n\t\t\t\t\t\t\t\t\t   :where [:and [:= :field.name field] [:= :dataset.name dataset]]}))))\n\t\t  sampleID (getfield \"sampleID\")]\n\t  {:samples (map :value (query {:select [:value]\n\t\t\t\t\t\t\t\t\t:from [:code]\n\t\t\t\t\t\t\t\t\t:where [:and [:in :value samples][:= :field_id sampleID]]}))\n\t   :rows (xena-query {:select [\"ref\" \"alt\" \"altGene\" \"effect\" \"dna-vaf\" \"rna-vaf\" \"amino-acid\" \"genes\" \"sampleID\" \"position\"]\n\t\t\t\t\t\t  :from [dataset]\n\t\t\t\t\t\t  :where [:and [:in \"position\" [[chr start end]]] [:in \"sampleID\" samples]]})}))\n"

/***/ }),
/* 40 */
/***/ (function(module, exports) {

	module.exports = "; transcriptExpression\n(fn [transcripts studyA subtypeA studyB subtypeB dataset]\n  (let [tcgaTypes\n        (map :value (query {:select [:value]\n                            :from [:code]\n                            :join [:field [:= :field_id :field.id]\n                                   :dataset [:= :dataset_id :dataset.id]]\n                            :where [:and [:= :dataset.name \"TcgaTargetGTEX_phenotype.txt\"]\n                                         [:= :field.name \"_sample_type\"]\n                                         [:not= :value [\"Control Analyte\" \"Solid Tissue Normal\"]]]}))\n        fetchSamples {\n          \"tcga\" (fn [subtype]\n                  ((xena-query {:select [\"sampleID\"]\n                                :from [\"TcgaTargetGTEX_phenotype.txt\"]\n                                :where [:and [:in \"_study\" [\"TCGA\"]]\n                                             [:in \"_sample_type\" tcgaTypes]\n                                             [:in \"detailed_category\" [subtype]]]})  \"sampleID\"))\n          \"gtex\" (fn [subtype]\n                  ((xena-query {:select [\"sampleID\"]\n                                :from [\"TcgaTargetGTEX_phenotype.txt\"]\n                                :where [:and [:in \"_study\" [\"GTEX\"]]\n                                             [:in \"_sample_type\" [\"Normal Tissue\"]]\n                                             [:in \"_primary_site\" [subtype]]]}) \"sampleID\"))}]\n    [(fetch [{:table dataset\n              :columns transcripts\n              :samples ((fetchSamples studyA) subtypeA)}])\n     (fetch [{:table dataset\n              :columns transcripts\n              :samples ((fetchSamples studyB) subtypeB)}])]))\n"

/***/ })
/******/ ]);